/* eslint-disable */
require('./checkbox')
require('./close')
require('./facebook')
require('./google')
require('./cancelar')



// WEBPACK FOOTER //
// ./src/icons/index.js